import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppointmentStore } from "src/features/appointment/services/useAppointmentStore";
import { useAuthStore } from "../../../auth/services/useAuthStore";
import { useClinicsStore } from "../../../clinics/services/useClinicsStore";
import "./HomePage.css";
import { HomeAppointments } from "./components/HomeAppointments/HomeAppointments";
import { HomeFavouriteDoctors } from "./components/HomeFavouriteDoctors/HomeFavouriteDoctors";
import { HomeParticipants } from "./components/HomeParticipants/HomeParticipants";

function HomePage() {
  const navigate = useNavigate();

  const authStore = useAuthStore();
  const clinicsStore = useClinicsStore();
  const appointmentStore = useAppointmentStore();

  useEffect(() => {
    if (!authStore.user.isLoggedIn) navigate("/");

    appointmentStore.clear();

    clinicsStore.clinicsList();
  }, []);

  return (
    <div className="homePage grid justify-content-center gap-1 md:gap-2">
      <div className="col-11 sm:col-10 md:col-10 lg:col-6 xl:col-5 flex-order-0">
        <HomeAppointments />
      </div>

      <div className="col-11 sm:col-10 md:col-5 lg:col-4 xl:col-3 flex-order-1">
        <HomeFavouriteDoctors />
      </div>

      <div className="col-11 sm:col-10 md:col-5 lg:col-4 xl:col-3 flex-order-2">
        <HomeParticipants />
      </div>
    </div>
  );
}

export default HomePage;
